module.exports = __webpack_public_path__ + "media/images/folder-e53166a0504406234ac987bbc97eed7f.svg";